export function Match(firstName1,lastName1,id1,firstName2,lastName2,id2,roomType) {
    this.firstName1 = firstName1;
    this.lastName1 = lastName1;
    this.id1 = id1;
    this.firstName2 = firstName2;
    this.lastName2 = lastName2;
    this.id2 = id2;
    this.roomType = roomType;
  }